module.exports = __webpack_public_path__ + "static/twitter_white_v1-c878f887aa794d4de8fdddfb70b8092d.png";